import React from 'react';
import {AbstractControl, FieldControl, GroupProps} from 'react-reactive-form';
import {FormControl, InputLabel} from '@mui/material';
import {DatePicker, DatePickerProps} from '@mui/x-date-pickers';
import {getErrorText, getVisibleErrors} from './utils';
import {tid} from '../../../testUtils';

type DateControlProps = GroupProps & {
  name: Required<GroupProps['name']>;
  DatePickerProps?: Partial<DatePickerProps>;
  label: string;
  plural?: boolean;
  required?: boolean;
  disabled?: boolean;
};

export const DateControl: React.FC<DateControlProps> = ({
  label,
  plural,
  required,
  disabled = false,
  DatePickerProps,
  ...FieldControlProps
}) => {
  return (
    <FieldControl
      strict={false}
      {...FieldControlProps}
      render={(renderProps) => {
        const {handler} = renderProps;
        const visibleErrors = getVisibleErrors(renderProps);
        const hasVisibleErrors = Object.keys(visibleErrors).length > 0;

        const {value, ...restHandlers} = handler();

        return (
          <FormControl fullWidth error={hasVisibleErrors} hiddenLabel={true} className="MuiFormControl-hem">
            <InputLabel shrink required={required ?? !!renderProps.validator?.({} as AbstractControl)}>
              {label}
            </InputLabel>
            <DatePicker
              format="MM/dd/yyyy"
              slotProps={{
                textField: {
                  variant: 'filled',
                  margin: 'dense',
                  error: hasVisibleErrors,
                  helperText: hasVisibleErrors && getErrorText(visibleErrors, String(label), plural),
                  inputProps: {
                    ...tid('input', FieldControlProps.name!),
                  },
                  label: '',
                  hiddenLabel: true,
                  disabled: disabled || restHandlers.disabled,
                },
              }}
              {...DatePickerProps}
              {...restHandlers}
              value={value || null}
            />
          </FormControl>
        );
      }}
    />
  );
};
